
import axios from "axios";
import { defineComponent, onMounted } from "vue";

import DefaultLogo from "@/assets/default-logo.jpg";

interface WechatWindow extends Window {
  wx: {
    config: (config: unknown) => void;
    checkJsApi: (config: unknown) => void;
    ready: (config: unknown) => void;
    // updateAppMessageShareData: (config: unknown) => void;
    // updateTimelineShareData: (config: unknown) => void;
    onMenuShareTimeline: (config: unknown) => void;
    onMenuShareAppMessage: (config: unknown) => void;
  };
}

export default defineComponent({
  setup() {
    const configureWechat = () => {
      if (/(^micromessenger| micromessenger)/gi.test(navigator.userAgent)) {
        const thisUri = location.href.split("#")[0];
        const imageUri = `https://${location.host}${DefaultLogo}`;

        const elInject = document.createElement("script");
        elInject.src = "//res.wx.qq.com/open/js/jweixin-1.4.0.js";
        elInject.async = true;
        elInject.onload = () => {
          const wechatWindow = window as unknown as WechatWindow;

          axios({
            url: `https://weixin.qz123.com/wxjssdk.php?url=${encodeURIComponent(
              thisUri
            )}`,
          })
            .then((res) => {
              wechatWindow.wx.config({
                appId: res.data["appId"],
                timestamp: res.data["timestamp"],
                nonceStr: res.data["nonceStr"],
                signature: res.data["signature"],
                jsApiList: [
                  // "updateAppMessageShareData",
                  // "updateTimelineShareData",
                  "onMenuShareTimeline",
                  "onMenuShareAppMessage",
                ],
              });

              wechatWindow.wx.ready(() => {
                const options = {
                  title: "战疫求助平台",
                  desc: "衢州广电传媒集团·无线衢州",
                  link: thisUri,
                  imgUrl: imageUri,
                };

                // wechatWindow.wx.updateAppMessageShareData(options);
                // wechatWindow.wx.updateTimelineShareData(options);
                wechatWindow.wx.onMenuShareTimeline(options);
                wechatWindow.wx.onMenuShareAppMessage(options);
              });
            })
            .catch((e) => {
              console.error(e);
            });
        };
        document.head.append(elInject);
      }
    };

    onMounted(() => {
      configureWechat();
    });
  },
});
